import MUIInputLabel, { InputLabelProps as MUIInputLabelProps } from '@material-ui/core/InputLabel';
import clsx from 'clsx';
import styles from '../../../styles/components/inputs/InputLabel.module.css';
import InfoIcon from '../../../../public/images/icons/info.svg';
import Tooltip from '@material-ui/core/Tooltip';
import { useId } from 'react';

export default function InputLabel(
  props: Omit<
    MUIInputLabelProps,
    'color' | 'disableAnimation' | 'focused' | 'margin' | 'shrink' | 'variant'
  > & { hint?: React.ReactNode }
) {
  const { hint, className, id, htmlFor, ...restProps } = props;
  const generatedId = useId();
  const fallbackId = htmlFor ? `${htmlFor}-label` : undefined;
  const labelId = (id ?? fallbackId ?? generatedId).replace(/:/g, '_');

  return (
    <MUIInputLabel
      {...restProps}
      id={labelId}
      htmlFor={htmlFor}
      className={clsx(styles.Label, className)}
      disableAnimation
      shrink={true}
    >
      {props.children}
      {!!hint && (
        <Tooltip
          classes={{
            tooltip: styles.Tooltip,
          }}
          title={hint}
          arrow
        >
          <div className={styles.hint}>
            <InfoIcon className={styles.InfoIcon} />
          </div>
        </Tooltip>
      )}
    </MUIInputLabel>
  );
}
